module.exports = __webpack_public_path__ + "img/bg.e2b52fe7.png";